module.exports = __webpack_public_path__ + "static/media/kz.a19240f6.svg";